import { getVideoParser } from '../common/utils';
export function initVideos(modules, triggers) {
    var parser = getVideoParser();
    modules.filter(function (m) { return m.name === 'Video'; }).forEach(function (_a) {
        var el = _a.el;
        var url = el.dataset.videoUrl;
        var hasPlaceholder = !!el.dataset.hasPlaceholder;
        var stub = el.querySelector('.-stub');
        if (!hasPlaceholder) {
            parser.getThumbnail(url).then(function (image) {
                if (image) {
                    stub.style.backgroundImage = "url(".concat(image, ")");
                }
            });
        }
        stub.addEventListener('click', function () {
            el.querySelector('video').play();
            el.removeChild(stub);
        });
    });
}
